class CintaColorPicker extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-cinta-input]');
    this.selectedLabel = this.querySelector('[data-cinta-selected]');
    this.swatches = Array.from(this.querySelectorAll('.cinta-color-picker__swatch'));

    this.swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => this.select(swatch));
    });
  }

  select(swatch) {
    const value = swatch.dataset.cintaValue;

    if (this.input) {
      this.input.value = value;
    }

    if (this.selectedLabel) {
      this.selectedLabel.textContent = value;
    }

    this.swatches.forEach((s) => {
      const isSelected = s === swatch;
      s.classList.toggle('is-selected', isSelected);
      s.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }
}

if (!customElements.get('cinta-color-picker')) {
  customElements.define('cinta-color-picker', CintaColorPicker);
}
